import { Avatar, BodySEmphasis, BodyXSPrimary, colors, type ComponentWrapperType } from "@cerebruminc/cerebellum";
import React, { type FC } from "react";
import { formatInviteString } from "../helpers";

import { AvatarWrapper, NameBase } from "../UserTableStyles";

export const NameCell: FC<ComponentWrapperType> = ({ row }) => {
	const isInvited = row.status === "INVITED";
	const primaryName = row.names.find((name: any) => name.type === "PRIMARY");

	const name = `${primaryName?.firstName || ""} ${primaryName?.lastName || ""}`;

	return (
		<NameBase>
			<AvatarWrapper>
				<Avatar
					backgroundGradient="linear-gradient(180deg, #5377EC 0%, #C0AAFF 56.31%, #FFFFFF 100%)"
					imageUrl={row.avatarUrl}
					placeholderInitials={`${row.firstName?.slice(0, 1)}${row.lastName?.slice(0, 1)}`}
					themeOverride={{ size: 50 }}
				/>
			</AvatarWrapper>
			<div>
				<BodySEmphasis $textColor={isInvited ? colors.COOL_GREY_65 : colors.COOL_GREY_100}>{name}</BodySEmphasis>
				{isInvited && (
					<BodyXSPrimary $textColor={colors.COOL_GREY_65}>{formatInviteString(row.lastInviteSentAt)}</BodyXSPrimary>
				)}
			</div>
		</NameBase>
	);
};
